import { render, staticRenderFns } from "./AssetMeta.vue?vue&type=template&id=282e1bea"
import script from "./AssetMeta.vue?vue&type=script&lang=js"
export * from "./AssetMeta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports